import { useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { formatBRLFromCents, parseCentsFromInput } from "../../../Funcoes/Money";
import { useNavigate } from "react-router-dom";
import { useModal } from "../../../contexts/ModalContext";

const ModalNovoBM = ({ pedidoCompra, fecharModal }) => {

    const navigate = useNavigate();
    const { closeModal } = useModal();

    const [formValues, setFormValues] = useState({
        idPc: pedidoCompra.id,
        //Deixar o númeoro da medição em branco para ser preenchido pelo usuário em forma de número inteiro
        numMedicao: "",
        //Deixar a data atual como valor inicial
        dataMedicao: new Date().toISOString().split("T")[0],
        valor: 0,
        fsr: "",
        observacoes: ""
    })

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormValues((prevValues) => {
            if (name === "valor") {
                return { ...prevValues, [name]: parseCentsFromInput(value) }
            }
            return { ...prevValues, [name]: value.toUpperCase() }
        })

    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        closeModal();
        navigate(`/modulo/controle-medicao/pedidos-compra/${pedidoCompra.id}/previsao-boletim`, { state: { pendingBM: formValues } });

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={fecharModal} >
                    <Formulario onSubmit={handleSubmit}>
                        <FormComp
                            title="OBRA"
                            type="text"
                            readOnly={true}
                        />
                        <FormComp
                            title="CONTRATO"
                            type="text"
                            readOnly={true}
                            valor={pedidoCompra.nome_projeto}
                        />
                        <FormComp
                            title="PEDIDO DE COMPRA"
                            type="text"
                            readOnly={true}
                            valor={pedidoCompra.num_pedido}
                        />
                        <FormComp
                            title="Nº MEDIÇÃO"
                            type="text"
                            valor={formValues.numMedicao}
                            changeFunc={handleChange}
                            name="numMedicao"
                        />
                        <FormComp
                            title="DATA MEDIÇÃO"
                            type="date"
                            valor={formValues.dataMedicao}
                            changeFunc={handleChange}
                            name="dataMedicao"
                        />
                        <FormComp
                            title="VALOR"
                            type="text"
                            inputMode="numeric"
                            valor={formatBRLFromCents(formValues.valor)}
                            name="valor"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="FSR"
                            type="text"
                            valor={formValues.fsr}
                            name="fsr"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="OBSERVAÇÕES"
                            type="textarea"
                            valor={formValues.observacoes}
                            name="observacoes"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            valor="SALVAR"
                            type="submit"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNovoBM;